import {TextLinkWidget} from '@tableau/widgets';
import * as React from 'react';

import { Messages } from '../../../../../codegen/Localize';
import {FormikCheckbox} from '../../../../../commonInfra/components/FormikCheckbox';
import {HelpService} from '../../../../../commonInfra/services/HelpService';
import { SettingsSection } from '../../../../components/common/SettingsSection';
import {learnMoreStyle} from '../../../../styles/CommonStyles';
import {componentRegistryEntry} from '../../SettingsComponentRegistryFunctions';

export const REMOTE_QUERYING_ENABLED_FIELD = 'settings.siteAdminBridgeSettings.remoteQueryingEnabled';

export function BridgePoolingSection() {
  return (
    <SettingsSection title={Messages.siteRemoteAgentSettingsAgentsPooling()}
                     testId={'bridge-pooling-section'}
                     description={renderDescription()}>

      <FormikCheckbox name={REMOTE_QUERYING_ENABLED_FIELD}
                      label={Messages.remoteAgentsAllowPoolingSiteSettingCheckbox()}
                      testId={'remote-querying-enabled'}>

      </FormikCheckbox>
    </SettingsSection>
  );
}

function renderDescription() {
  return <>
    <span>{Messages.siteRemoteAgentSettingsAgentsPooling_description()}</span>
    <TextLinkWidget testId={'bridge-pooling-learn-more'}
                    className={learnMoreStyle}
                    href={HelpService.getServerHelpUrlByCategory('bridge-pooling')}
                    target={'_blank'}>
      {Messages.siteRemoteAgentSettingsLearnMore()}
    </TextLinkWidget>
  </>;
}
/* for registering the component in settings registry */
export const BridgePoolingSectionSpecs = componentRegistryEntry({
  name: 'BridgePoolingSection',
  component: BridgePoolingSection
});
